import type {Theme} from "@mui/material/styles";

/** Top “Release Notes” heading. */
export const releaseNoteHeadingSx = (theme: Theme) => ({
    color: theme.palette.text.primary, fontWeight: theme.typography.fontWeightBold, fontSize: theme.spacing(3.5),
} as const);

/** Close “X” icon in the dialog title. */
export const closeIconSx = {
    position: "absolute", right: 8, top: 8,
} as const;

/** “Release 1.2.3” + date typography. */
export const releaseVersionSx = (theme: Theme) => ({
    color: theme.palette.text.primary, fontWeight: theme.typography.fontWeightBold, fontSize: theme.spacing(3),
} as const);

/** Container for the latest release block. */
export const latestContainerSx = (theme: Theme) => ({
    width: "100%", marginTop: theme.spacing(1),
} as const);

/** Row that aligns version on the left and date on the right. */
export const titleRowSx = (theme: Theme) => ({
    display: "flex", alignItems: "center", justifyContent: "space-between",
} as const);

/** List text size for features/bugfixes. */
export const listSx = (theme: Theme) => ({
    fontSize: theme.spacing(2.3), lineHeight: 1.5,
} as const);

/** CTA under the dialog to go to the full history. */
export const viewReleaseHistoryButtonSx = (theme: Theme) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    marginBottom: "1rem",
} as const);
